import React, { useCallback } from 'react'

import Button from '../../../shared_components/Button'
import store from '../SearchBar/stores/rootStoreInstance'
import { dispatchEventRemovePolygon } from '../../Shared/stores/utils'

const NoResultsInfo = () => {
  const handleResetFiltersClick = useCallback(() => {
    store.valueStateStore.resetAllInputs()
    store.valueStateStore.fetchDataForListings()
    store.valueStateStore.setInputValue('searchPolygon', [])
    store.valueStateStore.searchPolygon = []
    dispatchEventRemovePolygon()
  }, [])

  return (
    <React.Fragment>
      <div className='NoResultsInfo'>
        <p className='NoResultsInfo-information'>No matching results</p>
        <p className='NoResultsInfo-recomendation'>Please try entering different search criteria</p>
        <Button
          subType='black'
          variant='outline'
          size='medium'
          type='customer'
          onClick={handleResetFiltersClick}
        >
          Reset Filters
        </Button>
      </div>
      <div className='NoResultsInfo-line' />
    </React.Fragment>
  )
}

export default NoResultsInfo
